//Written by Luke Baumann in Sep. 2021 for Boxi
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Select, { Async } from "react-select";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col, FormGroup, Label, FormFeedback, Input } from "reactstrap";
import axios from "axios";
import DatePicker from "react-widgets/DatePicker";
import "react-widgets/styles.css";
import Moment from 'moment-timezone';
import parse from 'html-react-parser';

import classes from "./EditProblemModal.module.scss";
import Form from "./../../../general/Form/Form";

const config = {
  headers: {
    "Content-Type": "application/json"
  },
  withCredentials: true
};

const initialState = {
  truck_problem_id : "",
  truck_id : "",
  description : "",
  inputValue: "",
  bleeding_stopped: false,
  reprint_ordered: false,
  date_identified: "",
  target_close_date: "",
  solution: "",
  closed: false,
  boxi_owner_id: "",
  truck_options: [],
  truckOptionsLoaded: false,
  boxi_owner_options: [],
  boxiOwnerOptionsLoaded: false,
  isLoadingOptions: false,
  loadedTruckProblem: false,
};
//const colorOptions = ["Red", "Green", "Blue"];

// const filterOptions = (inputValue: string) => {
//
//   return allTruckStrings.filter(i =>
//     i.toLowerCase().includes(inputValue.toLowerCase())
//   );
// };
//
// const loadOptions = (inputValue, callback) => {
//   setTimeout(() => {
//     callback(filterOptions(inputValue));
//   }, 1000);
// };

class ProblemForm extends Component {

  state = initialState;

  //default constructor for now
  constructor(props){
    super(props);
    this.toggle = this.toggle.bind(this);
  };


  toggle = (refreshTable) => {
    this.props.toggleModal(refreshTable);
  };
  componentDidUpdate = async () =>{
    this.fetchModalData();
  };

  componentWillReceiveProps (nextProps){
    if (nextProps.edit && nextProps.data){
      this.setState(initialState);
      this.fetchModalData();
    }
    else if (!nextProps.edit){
      this.setState(initialState);
      this.handleLoadOptions();
    }

  }

  fetchModalData = async () => {
    if (this.props.edit && this.props.data && !this.state.loadedTruckProblem){
      let res = await axios.get(
        `${process.env.REACT_APP_API_HOST}/fixlist/${this.props.data.id}`,
        { withCredentials: true }
      );

      if (res.status === 200 && res.data.problem.rows[0]) {
        let truckProblem = res.data.problem.rows[0];
        this.setState({
          loadedTruckProblem: true,
          truck_problem_id: truckProblem.truck_problem_id,
          truck_id: truckProblem.truck_id,
          description: truckProblem.description,
          bleeding_stopped: truckProblem.bleeding_stopped,
          date_identified: truckProblem.date_identified,
          reprint_ordered: truckProblem.reprint_ordered,
          target_close_date: Date.parse(truckProblem.target_close_date),
          solution: truckProblem.solution,
          closed: truckProblem.closed,
          date_closed: truckProblem.date_closed,
          boxi_owner_id: truckProblem.boxi_owner_id,
        });
        this.handleLoadOptions();
      }
    }
  };

  handleLoadOptions = async (input, callback) => {

    let all_trucks_res;
    if (this.props.vendorPageId){
      all_trucks_res = await axios.get(`${process.env.REACT_APP_API_HOST}/vendor/${this.props.vendorPageId}/truck`,
        { withCredentials: true }
      );
    }
    else if (this.props.truckPageId){
      all_trucks_res = await axios.get(`${process.env.REACT_APP_API_HOST}/truck/${this.props.truckPageId}`,
        { withCredentials: true }
      );
    }
    else {
      all_trucks_res = await axios.get(
        `${process.env.REACT_APP_API_HOST}/truck`,
        { withCredentials: true }
      );
    }
    let all_boxi_owners_res = await axios.get(`${process.env.REACT_APP_API_HOST}/user/admin`,
      { withCredentials: true}
    );
    if (all_trucks_res.status === 200 && (all_trucks_res.data.trucks || all_trucks_res.data.truck)){
      let all_trucks_select_string = [];
      let all_truck_res_data = all_trucks_res.data.trucks ? all_trucks_res.data.trucks : all_trucks_res.data.truck;
      all_truck_res_data.map((truck) => {
        const newOption = {
          value: truck.truck_id,
          label: truck.name + " - " + truck.vendor_name + " (" + truck.license_plate + ")",
        };
        all_trucks_select_string.push(newOption);
      });
      let truckLabel = this.props.edit ? all_trucks_select_string.find(opt => opt.value == this.state.truck_id) : "";
      this.setState({
        truck_options: all_trucks_select_string,
        isLoading: false,
        truckOptionsLoaded: true,
        currentTruckOption: truckLabel,
      });
    }
    if (all_boxi_owners_res.status === 200 && all_boxi_owners_res.data){
      let all_owners_select_string = [];
      all_boxi_owners_res.data.admin.map((user) => {
        const newOption = {
          value: user.user_id,
          label: user.name,
        };
        all_owners_select_string.push(newOption);

      });
      let boxiOwnerLabel = this.props.edit ? all_owners_select_string.find(opt => opt.value == this.state.boxi_owner_id) : "";
      this.setState({
        boxi_owner_options: all_owners_select_string,
        isLoading:false,
        boxiOwnerOptionsLoaded: true,
        currentBoxiOwnerOption: boxiOwnerLabel,
      });

    }
  };

  onFormSubmitHandler = async (e) => {
    e.preventDefault();
    let problemData = {
      truck_problem_id: this.state.truck_problem_id,
      description: this.state.description,
      truck_id: this.state.truck_id,
      bleeding_stopped: this.state.bleeding_stopped,
      date_identified: Moment(this.state.date_identified).format("YYYY-MM-DD"),
      reprint_ordered: this.state.reprint_ordered,
      target_close_date: Moment(this.state.target_close_date).format("YYYY-MM-DD"),
      solution: this.state.solution,
      closed: this.state.closed,
      date_closed: this.state.date_closed,
      boxi_owner: this.state.boxi_owner_id,
    }
    let valid_input = this.validateInput(problemData);


    if (valid_input && this.props.edit){
      try{
        let res = await axios.put(`${process.env.REACT_APP_API_HOST}/fixlist/${this.state.truck_problem_id}`, problemData, config);
        if (res.status === 200 && res.data.updated_fix_list_item){
          alert("Fix list item was updated successfully");
          this.toggle(true);
        }
      }catch (err){
        console.log(err);
      }
    }
    else if (valid_input) {
      try{
        let res = await axios.post(`${process.env.REACT_APP_API_HOST}/fixlist`, problemData, config);
        if (res.status === 200 && res.data.new_fix_list_item){
          alert("Fix list item was created successfully");
          this.toggle(true);
        }
      } catch (err){
        console.log(err);
      }
    }
  };
  validateInput = (problemData) => {
    let valid = true;
    let invalid_reasons = "Please fix the following errors:\n"
    if (!problemData.truck_id){
      valid = false;
      invalid_reasons = invalid_reasons.concat("- Select a valid truck\n");
    }
    if (!problemData.description){
      valid = false;
      invalid_reasons = invalid_reasons.concat("- Description cannot be blank\n");
    }
    if (!problemData.date_identified || problemData.date_identified=='Invalid date'){
      valid = false;
      invalid_reasons = invalid_reasons.concat("- Date identified cannot be blank\n");
    }
    if (!problemData.target_close_date || problemData.target_close_date=='Invalid date'){
      valid = false;
      invalid_reasons = invalid_reasons.concat("- Target close date cannot be blank\n");
    }
    if (!valid){
      alert(invalid_reasons);
    }
    return valid;
  };

  maybeLoadOptions = () => {
    if (!this.state.truckOptionsLoaded && !this.props.vendorId) {
      this.setState({ isLoading: true })
      this.handleLoadOptions()
    }
  };
  truckIdChangeHandler = (e) => {
    this.setState({
      currentTruckOption: this.state.truck_options.find(opt => opt.value == e.value),
      truck_id: e.value,
    })
  }
  descriptionChangeHandler = (e) => {
    this.setState({
      description: e.target.value,
    });
  };
  bleedingStoppedChangeHandler = (e) => {
    this.setState({
      bleeding_stopped: e.target.checked,
    });
  };
  dateIdentifiedChangeHandler = (date) => {
    this.setState({
      date_identified: date,
    });
  };
  reprintOrderedChangeHandler = (e) => {
    this.setState({
      reprint_ordered: e.target.checked,
    });
  };
  targetCloseDateChangeHandler = (date) => {
    this.setState({
      target_close_date: date,
    });
  };
  solutionChangeHandler = (e) => {
    this.setState({
      solution: e.target.value,
    });
  };
  boxiOwnerChangeHandler = (e) => {
    this.setState({
      currentBoxiOwnerOption: this.state.boxi_owner_options.find(opt => opt.value == e.value),
      boxi_owner_id: e.value,
    })
  };
  deleteTruckProblemHandler = async (e) => {
    e.preventDefault();
    let truck_problem_id = this.state.truck_problem_id;
    let res = await axios.delete(`${process.env.REACT_APP_API_HOST}/fixlist/${truck_problem_id}`,
    { withCredentials: true , data:{truck_problem_id: truck_problem_id} } );
      if (res.status === 200 && res.data.deleted_fix_list_item[0].truck_problem_id == truck_problem_id){
        alert("Successfully deleted fix list item");
        this.toggle(true);
      }
      else {
        alert("Error deleting fix list item");
        //this.toggle(false);
      }
  }
  closeTruckProblemHandler = (e) => {
    this.setState({
      closed: true,
      date_closed: Moment().format("YYYY-MM-DD"),

    }, () => this.onFormSubmitHandler(e));
  };
  reopenTruckProblemHandler = (e) => {
    this.setState({
      closed: false,
    }, () => this.onFormSubmitHandler(e));
  }

  // generateStringFromTruckData(truck) {
  //   if (truck.name && truck.license_plate && truck.vendor_name){
  //     return ({value: truck.truck_id, label: truck.name + " - " + truck.vendor_name + " ("  + truck.license_plate + ")",
  //   });
  //   }
  // }
  // //For searchable select box
  // handleInputChange = (newValue: string) => {
  //     const inputValue = newValue.replace(/\W/g, '');
  //     this.setState({ inputValue });
  //     return inputValue;
  //   };

  render() {
    const style = {
      padding: "15px 20px"
    };
    const sectionStyle = {
      boxShadow: "none"
    };
    const buttonStyle = {
      float: "right",
      marginLeft: "20px",
      width: "100px"
    };
    return (
      <Modal isOpen={this.props.show} toggle={() => this.toggle(false)} className="modal-xl">
      <ModalHeader toggle={() => this.toggle(false)}>{this.props.edit ? "Edit Fix List Item" : "New Fix List Item"}</ModalHeader>
      <ModalBody>
      <Form sectionStyle={sectionStyle} formStyle={style}>
      <fieldset disabled={this.state.closed}>
      <Row>
      <Col md={6}>
      <Row form className="mb-4">
      <div style={{ "width" : "70%" }}>
      <FormGroup>
      <Label for="truck_id">Select Truck - start typing to search</Label>
      <Select
      searchable={true}
      autoload={false}
      value={this.state.currentTruckOption}
      isLoading={this.state.isLoading}
      options={this.state.truck_options}
      onFocus={this.maybeLoadOptions}
      onChange={this.truckIdChangeHandler}
      />
      </FormGroup>
      </div>
      </Row>
      <Row form className="mb-4">
      <FormGroup style = {{"width" : "80%"}}>
      <Label for="problem_description">Description</Label>
      <Input
      type="textarea"
      style={{ height: 120}}
      value={this.state.description ? this.state.description : ""}
      onChange={this.descriptionChangeHandler}
      placeholder="Enter problem description"
      />
      </FormGroup>
      </Row>
      <Row form className="mb-4">
      <FormGroup>
      <Label for="date_identified">Date Identified</Label>
      <DatePicker
      value={this.state.date_identified ? new Date(this.state.date_identified):null}
      onChange={date => this.dateIdentifiedChangeHandler(date)}
      valueFormat={{ dateStyle: "medium" }}
      />
      </FormGroup>
      </Row>
      <Row form className="mb-4">
      <FormGroup>
      <Label for="target_close_date">Target Close Date</Label>
      <DatePicker
      value={this.state.target_close_date ? new Date(this.state.target_close_date) : null}
      onChange={date => this.targetCloseDateChangeHandler(date)}
      valueFormat={{ dateStyle: "medium" }}
      />
      </FormGroup>
      </Row>

      </Col>
      <Col md={6}>
      <Row form className="mb-4">
      <FormGroup>
      <Label>Bleeding Stopped?  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Label>
      <Input
      type="checkbox"
      checked={!!this.state.bleeding_stopped}
      onChange={this.bleedingStoppedChangeHandler}
      />
      </FormGroup>
      </Row>
      <Row form className="mb-4">
      <FormGroup>
      <Label>Reprint Ordered? &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Label>
      <Input
      type="checkbox"
      checked={!!this.state.reprint_ordered}
      onChange={this.reprintOrderedChangeHandler}
      />
      </FormGroup>
      </Row>
      <Row form className="mb-4">
      <FormGroup style = {{"width": "80%"}}>
      <Label for="solution">Solution</Label>
      <Input
      type="textarea"
      style={{ height: 120}}
      value={this.state.solution ? this.state.solution : ""}
      onChange={this.solutionChangeHandler}
      placeholder="Describe planned solution"
      />
      </FormGroup>
      </Row>
      <Row form className="mb-4">
      <div style={{"width": "70%"}}>
      <FormGroup>
      <Label for="truck_id">Boxi Owner</Label>
      <Select
      searchable={true}
      autoload={false}
      value={this.state.currentBoxiOwnerOption}
      isLoading={this.state.isLoading}
      options={this.state.boxi_owner_options}
      onFocus={this.maybeLoadOptions}
      onChange={this.boxiOwnerChangeHandler}
      />
      </FormGroup>
      </div>
      </Row>
      </Col>
      </Row>
      </fieldset>
      </Form>
      </ModalBody>

      {this.state.closed && (
        <ModalFooter>
        <div className = {classes.footer_message}>{parse("This fix list item was marked as closed on: " + Moment(this.state.date_closed).format("YYYY-MM-DD") + "<br >To make changes you must reopen this item.")}</div>
        <Button color="warning" onClick={this.reopenTruckProblemHandler}>
        Reopen
        </Button>
        </ModalFooter>
      )}

      {!this.state.closed && (
        <ModalFooter>
        <Row>
        <Button className = {classes.btn_footer} color="warning" onClick={this.closeTruckProblemHandler}>
        Mark as Closed</Button>
        <Button className = {classes.btn_footer} color="success" onClick={this.onFormSubmitHandler}>
        Save
        </Button>
        <Button className = {classes.btn_footer} color="secondary" onClick={() => this.toggle(false)}>
        Cancel
        </Button>
        </Row>
        </ModalFooter>
      )}

      </Modal>
    );
  }
}

export default ProblemForm;
